// Utility function to format MCC, MID, CID labels
const formatLabel = str => {
  const lowercaseExceptions = ['and', 'of', 'by']
  return str
    .toLowerCase()
    .replace(/_/g, ' ')
    .split(' ')
    .map((word, index) => {
      if (index === 0 || !lowercaseExceptions.includes(word)) {
        return word.charAt(0).toUpperCase() + word.slice(1)
      } else {
        return word
      }
    })
    .join(' ')
}

export { formatLabel }
